<script>
import LongCollapsableText from './TextSubElement/LongCollapsableText.vue';

export default {
  components: { LongCollapsableText },
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.org.updateWebsite.p1')}}
    <div class="news-addition-info">
      <LongCollapsableText :news-id="news.id" :text="news.textParams[2]"/>
    </div>
  </div>
</template>
